/**
 * API URL resolution — keep local dev aligned with production/cPanel.
 *
 * Default: same-origin `/api` (Apache/MAMP/cPanel proxy in prod; setupProxy.js in CRA dev).
 * Override with REACT_APP_API_URL only when pointing at a remote API directly.
 */
const normalizeApiBase = (value: string): string => value.replace(/\/$/, '');

export const API_BASE_URL = (() => {
  const configured = process.env.REACT_APP_API_URL?.trim();
  if (configured) {
    return normalizeApiBase(configured);
  }
  return '/api';
})();

/** Origin without /api suffix — for static assets like receipt images. */
export const API_ORIGIN = (() => {
  if (API_BASE_URL.startsWith('http://') || API_BASE_URL.startsWith('https://')) {
    return API_BASE_URL.replace(/\/api\/?$/, '') || API_BASE_URL;
  }
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return process.env.REACT_APP_PROXY_TARGET || 'http://127.0.0.1:5001';
})();
